export const PRODUCT_TYPE = {
    EVENT: 'event',
    GROUP: 'group',
    OBJECT: 'object',
    EMPLOYEE: 'employee',
};
